import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";

export default function TrustpilotWidgetAdmin() {
  const [snippet, setSnippet] = useState("");
  const [widget, setWidget] = useState(null);

  useEffect(() => {
    api.get("/site/trustpilot-widget").then((r) => setWidget(r.data.widget));
  }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/admin/trustpilot-widget", { snippet });
      setWidget(data.widget);
      setSnippet("");
      toast.success("TrustBox is live on the homepage.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save the widget.");
    }
  };
  const clear = async () => {
    await api.delete("/admin/trustpilot-widget");
    setWidget(null);
    toast.success("TrustBox hidden.");
  };

  return (
    <section className="border border-obsidian-600 p-6 mt-10" data-testid="trustpilot-widget-admin">
      <h2 className="font-serif text-2xl text-bone-100 mb-2">Trustpilot widget (homepage)</h2>
      <p className="font-sans text-sm text-bone-400 mb-5">
        In Trustpilot Business → Integrations → TrustBox, copy the code and paste it here. Only Trustpilot's own settings are kept.
        {widget ? ` Live · template ${widget.attrs["data-template-id"]}.` : " Currently hidden."}
      </p>
      <Textarea
        value={snippet}
        onChange={(e) => setSnippet(e.target.value)}
        placeholder={'<div class="trustpilot-widget" data-locale="en-US" data-template-id="…" data-businessunit-id="…">…</div>'}
        className="min-h-[110px] bg-obsidian-800 border-obsidian-600 rounded-none text-bone-100 font-mono text-xs mb-3"
        data-testid="trustpilot-widget-snippet"
      />
      <div className="flex gap-3">
        <Button onClick={save} disabled={snippet.trim().length < 20} data-testid="trustpilot-widget-save" className="rounded-none bg-terracotta hover:bg-terracotta-deep text-obsidian-900 uppercase tracking-wider text-xs">
          Save & show
        </Button>
        {widget && (
          <Button onClick={clear} data-testid="trustpilot-widget-clear" className="rounded-none bg-transparent border border-obsidian-600 text-bone-400 hover:text-terracotta hover:bg-transparent uppercase tracking-wider text-xs">
            Hide widget
          </Button>
        )}
      </div>
    </section>
  );
}
